import React from 'react';
import { Collapse } from 'antd';
import Styles from '../../styles/m_viewStyles.less';

interface IMetadataCollapse {
    metadata?: Record<string, string>;
}

const { Panel } = Collapse;

export function MetadataCollapse({ metadata }: IMetadataCollapse) {
    return (
        <Collapse style={{ marginTop: '10px' }} bordered={false}>
            <Panel key={'Metadata'} header={'Metadata'}>
                {metadata &&
                    Object.entries(metadata).map(([key, value]) => {
                        const labelText = key
                            .replace(/([A-Z])/g, ' $1')
                            .replace(/^./, (str) => str.toUpperCase())
                            .trim();

                        return (
                            <div key={key} className={Styles.expandedRowLine}>
                                <div className={Styles.expandedRowLineLabel}>{labelText}</div>
                                <div className={Styles.expandedRowLineValue}>{value}</div>
                            </div>
                        );
                    })}
            </Panel>
        </Collapse>
    );
}
